import { render, staticRenderFns } from "./LawStatistic.vue?vue&type=template&id=31509acf"
import script from "./LawStatistic.vue?vue&type=script&lang=js"
export * from "./LawStatistic.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports